import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar, IconButton, Alert, Typography, Tooltip } from '@mui/material';
// utils
import { bgBlur } from '../../../utils/cssStyles';
// components
import Iconify from '../../../components/iconify';
//
import Logo from '../../../components/logo';
import Searchbar from './Searchbar';
import AccountPopover from './AccountPopover';
import LanguagePopover from './LanguagePopover';
import NotificationsPopover from './NotificationsPopover';
import useResponsive from 'hooks/useResponsive';
import Label from 'components/label/Label';

// ----------------------------------------------------------------------

const NAV_WIDTH = 250;

const HEADER_MOBILE = 64;

const HEADER_DESKTOP = 92;

const StyledRoot = styled(AppBar)(({ theme }) => ({
  ...bgBlur({ color: theme.palette.background.default }),
  boxShadow: 'none',
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${NAV_WIDTH + 1}px)`,
  },
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: HEADER_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: HEADER_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

// ----------------------------------------------------------------------

Header.propTypes = {
  onOpenNav: PropTypes.func,
};

const OverflowTypography = styled(Typography)(() => ({
  maxWidth: 200, // percentage also works
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis"
}));

export default function Header({ onOpenNav }) {
  const isSmall = useResponsive('', 'xs');
  return (
    <StyledRoot>
      <StyledToolbar>
        <IconButton
          onClick={onOpenNav}
          sx={{
            mr: 1,
            color: 'text.primary',
            display: { lg: 'none' },
          }}
        >
          <Iconify icon="eva:menu-2-fill" />
        </IconButton>

        
        <Box sx={{ pr: 2.5, py: 3, display: 'none', flexGrow: 1, }}>
          <Logo sx={{ display: { lg: 'none' } }} />
        </Box>
        {/* <Searchbar /> */}
        <Box sx={{ py: 3, flexGrow: 1, display: 'inline-flex', flexGrow: 1, }}>
          <Tooltip title={ `Service hours: ${process.env?.REACT_APP_SERVICE_HOURS}` } arrow>
          {isSmall ?
            <OverflowTypography noWrap><Label color='primary' sx={{ fontSize: 11 }}>Service hrs: <b>{ process.env?.REACT_APP_SERVICE_HOURS }</b></Label></OverflowTypography>
            : <Alert severity="info" sx={{ fontSize: 13 }}> 
              Service hours: <b>{ process.env?.REACT_APP_SERVICE_HOURS }</b>
            </Alert>
          }
          </Tooltip>
        </Box>
        <Stack
          direction="row"
          alignItems="center"
          spacing={{
            xs: 0.5,
            sm: 1,
          }}
        >
          <LanguagePopover />
          {/* <NotificationsPopover /> */}
          <AccountPopover />
        </Stack>
      </StyledToolbar>
    </StyledRoot>
  );
}
